var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_7359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_7359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C7.125 15.75 5.53125 15.0938 4.21875 13.7812C2.90625 12.4688 2.25 10.875 2.25 9C2.25 7.125 2.90625 5.53125 4.21875 4.21875C5.53125 2.90625 7.125 2.25 9 2.25C9.175 2.25 9.34688 2.25625 9.51562 2.26875C9.68437 2.28125 9.85 2.3 10.0125 2.325C9.5 2.6875 9.09063 3.15938 8.78438 3.74063C8.47813 4.32188 8.325 4.95 8.325 5.625C8.325 6.75 8.71875 7.70625 9.50625 8.49375C10.2937 9.28125 11.25 9.675 12.375 9.675C13.0625 9.675 13.6937 9.52188 14.2687 9.21563C14.8438 8.90938 15.3125 8.5 15.675 7.9875C15.7 8.15 15.7188 8.31563 15.7313 8.48438C15.7438 8.65312 15.75 8.825 15.75 9C15.75 10.875 15.0938 12.4688 13.7812 13.7812C12.4688 15.0938 10.875 15.75 9 15.75ZM9 14.25C10.1 14.25 11.0875 13.9469 11.9625 13.3406C12.8375 12.7344 13.475 11.9438 13.875 10.9688C13.625 11.0312 13.375 11.0813 13.125 11.1187C12.875 11.1562 12.625 11.175 12.375 11.175C10.8375 11.175 9.52812 10.6344 8.44687 9.55313C7.36562 8.47188 6.825 7.1625 6.825 5.625C6.825 5.375 6.84375 5.125 6.88125 4.875C6.91875 4.625 6.96875 4.375 7.03125 4.125C6.05625 4.525 5.26562 5.1625 4.65938 6.0375C4.05313 6.9125 3.75 7.9 3.75 9C3.75 10.45 4.2625 11.6875 5.2875 12.7125C6.3125 13.7375 7.55 14.25 9 14.25Z",
    fill: "#23A0E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.a894338f6fc15a15141229d3b6f32485.svg";
export { ForwardRef as ReactComponent };